import "../index.css";
import "../style.css";
import "../App.css";

import { bootstrapAndMount } from "./bootstrapAndMount";

bootstrapAndMount().catch((e) => {
  console.error("[incluway-widget] init failed", e);
});
